import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      publish: { icon: 'CheckCircle2', color: 'text-success' },
      login: { icon: 'LogIn', color: 'text-primary' },
      approval: { icon: 'ThumbsUp', color: 'text-accent' },
      edit: { icon: 'Edit', color: 'text-warning' },
      delete: { icon: 'Trash2', color: 'text-error' },
      upload: { icon: 'Upload', color: 'text-primary' }
    };

    return iconMap?.[type] || { icon: 'Activity', color: 'text-muted-foreground' };
  };

  const formatTimeAgo = (date) => {
    const now = new Date();
    const activityDate = new Date(date);
    const diffInMinutes = Math.floor((now - activityDate) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays}d ago`;
  };

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Recent Activity</h2>
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => {
          const iconConfig = getActivityIcon(activity?.type);
          return (
            <div key={activity?.id} className="flex items-start gap-3">
              <div className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0 ${iconConfig?.color}`}>
                <Icon name={iconConfig?.icon} size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground">
                  <span className="font-medium">{activity?.user}</span> {activity?.action}
                </p>
                {activity?.target && (
                  <p className="text-sm text-muted-foreground truncate">{activity?.target}</p>
                )}
                <p className="text-xs text-muted-foreground mt-1">{formatTimeAgo(activity?.timestamp)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityFeed;